let result;

export const getInfinteScroll = () => {
  if (result) return Promise.resolve(result);
  return import('./load-more').then((module) => {
    result = module;
    return module;
  });
};